import { makeStyles, tokens } from "@fluentui/react-components";
const root = {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingHorizontalXS,
    width: "100%"
};
const dropdown = {
    borderRadius: tokens.borderRadiusXLarge,
    height: tokens.spacingVerticalXXXL,
    minWidth: tokens.spacingHorizontalNone,
    overflow: "hidden",
    "::after": {
        content: "unset"
    },
    ":active,:focus-within": {
        borderBottomColor: tokens.colorCompoundBrandStroke
    },
    ":hover:focus-within": {
        borderBottomColor: tokens.colorCompoundBrandStroke
    },
    "&[aria-expanded='true'], &[aria-expanded='true']:hover": {
        borderBottomColor: tokens.colorCompoundBrandStroke
    }
};
const baseButtonStyle = {
    display: "flex",
    justifyContent: "flex-start",
    minWidth: 0,
    overflow: "hidden",
    paddingTop: "1px",
    fontWeight: tokens.fontWeightRegular,
    padding: "0px"
};
const dropdownButton = {
    ...baseButtonStyle,
    gap: tokens.spacingHorizontalXS
};
const optionButton = {
    ...baseButtonStyle,
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalXS
};
/**
 * Heading container styles for dropdown heading.
 */ const headingContainer = {
    padding: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalXXL}`,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground2,
    fontSize: tokens.fontSizeBase200
};
const optionIcon = {
    display: "flex",
    alignItems: "center",
    flexShrink: 0
};
const optionText = {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
};
const dropdownItem = {
    height: "18px"
};
// !important is required because priority/status icons (via IconUtilities) render with
// inline style={{ color }} hardcoded hex values that override CSS. On hover in Teams
// Contrast theme, the option background turns cyan while icons stay white — unreadable.
// inherit lets the icon color follow the parent Option's themed hover foreground color.
const highContrastDropdownIcon = {
    ":hover": {
        "& svg": {
            color: `inherit !important`
        }
    }
};
const selectedDropdownItem = {};
/* Callout has been replaced with Listbox in Fluent UI v9 */ const listbox = {
    borderRadius: tokens.borderRadiusXLarge,
    maxHeight: "280px !important"
};
const label = {
    padding: ` ${tokens.spacingVerticalXS} ${tokens.spacingHorizontalNone}`
};
const button = {};
export const useStyles = makeStyles({
    root,
    dropdown,
    dropdownButton,
    button,
    optionButton,
    optionIcon,
    optionText,
    dropdownItem,
    highContrastDropdownIcon,
    selectedDropdownItem,
    listbox,
    label,
    headingContainer
});
